import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `gatsby`,

  name: {
    [LOCALES.EN_US]: `Gatsby`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.framework, TYPES.tool],

  tags: [],
} as const satisfies TTerm
